export default __webpack_public_path__ + "CircularCustCapNum-MediumItalic.e0b646314aaf6bd3ff0876f01c91b574.woff2";